module.exports = __webpack_public_path__ + "img/a011_8.d854e26b.png";